var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg104DownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.171,290.89c-7.801-7.82-20.465-7.835-28.285-0.035L270.142,466.166c-7.797,7.797-20.487,7.797-28.302-0.018 L66.115,290.855c-7.82-7.8-20.484-7.785-28.285,0.035c-7.801,7.821-7.785,20.485,0.035,28.286L213.57,494.451 C225.271,506.152,240.639,512,256.005,512c15.36,0,30.72-5.845,42.405-17.531l175.725-175.293 C481.956,311.374,481.972,298.71,474.171,290.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0c-11.047,0-20.001,8.954-20.001,20.001v362.018c0,11.047,8.954,20.001,20.001,20.001s20.001-8.954,20.001-20.001 V20.001C276.001,8.954,267.046,0,256,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg104DownArrow);
export default __webpack_public_path__ + "static/media/104-down-arrow.d56799b9fad23cc3ff8fb840c6c3249a.svg";
export { ForwardRef as ReactComponent };